import { CountryOptions } from '@invitae/location-lite-core';

var getCountryOptionByLocale = function (locale, options) {
    var emptyOption = { label: '', value: '' };
    var countryOption = (options || CountryOptions).find(function (_a) {
        var value = _a.value;
        return locale === value;
    });
    return !locale || !countryOption ? emptyOption : countryOption;
};

export { getCountryOptionByLocale };
//# sourceMappingURL=defaults.esm.js.map
